import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
export function ComparisonSection() {
  return <section id="elegir" className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto scroll-mt-20" data-id="element-25">
      <div className="text-center mb-10 sm:mb-14" data-id="element-26">
        <p className="text-base sm:text-lg text-brand-text/80 font-medium mb-4" data-id="element-27">
          Podés empezar con lo básico… o tener TODO desde el primer día
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-brand-text font-bold leading-tight" data-id="element-28">
          Elegí cómo querés empezar
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-stretch" data-id="element-29">
        {/* Columna 1 - Kit Inicial */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-card rounded-[2rem] p-6 sm:p-8 border-2 border-brand-warm shadow-md flex flex-col relative mt-4 md:mt-8" data-id="element-30">
          <div className="text-center mb-6" data-id="element-31">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text mb-2" data-id="element-32">
              KIT INICIAL
            </h3>
            <p className="text-brand-text/80 font-medium text-lg" data-id="element-33">
              +200 plantillas para empezar desde cero
            </p>
          </div>

          <p className="text-brand-text font-bold mb-4" data-id="element-34">Incluye:</p>
          <ul className="space-y-4 mb-8 flex-grow" data-id="element-35">
            {['Guía paso a paso + videos', 'Plantillas listas para imprimir y crear', 'Mini guías de llaveros y lapiceras', 'Ideas de decoración y souvenirs', 'Ideal para empezar simple y crear tus primeras piezas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text" data-id="element-36">
                <CheckCircle2 className="w-5 h-5 text-brand-olive shrink-0 mt-0.5" data-id="element-37" />
                <span className="font-medium" data-id="element-38">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mt-auto" data-id="element-39">
            <div className="text-4xl sm:text-5xl font-bold text-brand-text font-serif mb-6" data-id="element-40">
              $19.990
            </div>
            <a href="https://pago.atlasdigitalhub.com/cart/42976083411042:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 rounded-full border-2 border-brand-cta text-brand-cta font-bold text-lg uppercase tracking-wider hover:bg-brand-cta hover:text-white transition-colors duration-300 text-center" data-id="element-41">
              QUIERO EMPEZAR
            </a>
          </div>
        </motion.div>

        {/* Columna 2 - Mega Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-brand-card rounded-[2rem] p-6 sm:p-8 border-4 border-brand-cta shadow-2xl flex flex-col relative" data-id="element-42">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-cta-hover text-white px-6 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider flex items-center gap-2 shadow-md whitespace-nowrap" data-id="element-43">
            <Star className="w-4 h-4 fill-white" data-id="element-44" />
            MÁS ELEGIDO
          </div>

          <div className="text-center mb-6 mt-4" data-id="element-45">
            <h3 className="text-3xl sm:text-4xl font-serif font-bold text-brand-cta mb-2" data-id="element-46">
              MEGA KIT
            </h3>
            <p className="text-brand-text/80 font-medium text-lg" data-id="element-47">
              +300 plantillas + packs más demandados
            </p>
          </div>

          <ul className="space-y-4 mb-8 flex-grow" data-id="element-48">
            {['Todo el Kit Inicial', 'Pack Baby Shower', 'Pack Bautismo & Comunión', 'Pack Aros Decorativos', 'Pack Deco Infantil', 'Packs exclusivos para crear más variedad desde el primer día'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text" data-id="element-49">
                <CheckCircle2 className="w-5 h-5 text-brand-cta shrink-0 mt-0.5" data-id="element-50" />
                <span className={i === 0 ? 'font-bold' : 'font-medium'} data-id="element-51">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="text-center mt-auto bg-brand-warm/30 rounded-2xl p-4 sm:p-6 border border-brand-warm" data-id="element-52">
            <p className="text-brand-cta font-bold text-xl sm:text-2xl mb-2 font-serif" data-id="element-53">
              Y TODO POR SOLO
            </p>
            <div className="flex flex-col items-center gap-1 mb-4" data-id="element-54">
              <span className="text-xl text-brand-muted line-through font-serif decoration-brand-cta/50 decoration-2" data-id="element-55">
                $49.990
              </span>
              <span className="text-5xl sm:text-6xl font-bold text-brand-text font-serif leading-none" data-id="element-56">
                $29.990
              </span>
            </div>

            <p className="text-brand-bonus font-bold text-sm sm:text-base mb-2" data-id="element-57">
              Accedé a todos los packs desde el primer día sin pagar extra
            </p>

            <a href="https://pago.atlasdigitalhub.com/cart/42976083443810:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 rounded-full bg-brand-cta text-white font-bold text-lg uppercase tracking-wider hover:bg-brand-cta/90 transition-colors duration-300 shadow-xl text-center" data-id="element-58">
              QUIERO EL MEGA
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}